export function getExperimentValue(experimentKey) {
  const experimentContainer = document.querySelector(
    `[data-variant-key=${experimentKey}]`,
  );

  const experimentValue = experimentContainer?.getAttribute(
    'data-variant-value',
  );

  return experimentValue || '';
}
